import { motion } from "framer-motion";
import { Linkedin, Mail } from "lucide-react";

const team = [
  {
    name: "Ahmet İnci",
    role: "Kurucu / Genel Müdür",
    image:
      "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb258ZW58MHx8fHwxNzgxMDI4MDA0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Burak Şahin",
    role: "Üretim Direktörü",
    image: "https://images.pexels.com/photos/4170184/pexels-photo-4170184.jpeg",
  },
  {
    name: "Elif Doğan",
    role: "Kalite & AR-GE Yöneticisi",
    image: "https://images.pexels.com/photos/37687676/pexels-photo-37687676.jpeg",
  },
];

export default function Team() {
  return (
    <section
      id="ekibimiz"
      data-testid="team-section"
      className="bg-[#fafafa] py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-12">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#FF5A00]/10 text-[#FF5A00] font-mono-disp text-[11px] font-medium">
              <span className="w-1.5 h-1.5 rounded-full bg-[#FF5A00]" />
              Ekibimiz
            </div>
            <h2 className="font-display mt-5 text-4xl sm:text-5xl md:text-6xl font-semibold tracking-tighter text-gray-900 leading-[1.02]">
              Tecrübeli kadromuzla{" "}
              <span className="font-serif-disp font-normal text-[#FF5A00]">
                sahada
              </span>{" "}
              ve atölyede.
            </h2>
          </div>
          <p className="lg:col-span-5 font-body text-base text-gray-600">
            Mühendislerimiz, ustalarımız ve saha ekibimiz; uluslararası kalite
            sertifikalarına sahip üretim hatlarımızda 7/24 çalışıyor.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {team.map((m, idx) => (
            <motion.div
              key={m.name}
              data-testid={`team-card-${idx}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: idx * 0.1 }}
              className="group relative rounded-[1.5rem] overflow-hidden bg-white shadow-[0_20px_50px_-25px_rgba(0,0,0,0.2)] border border-gray-100 hover:shadow-[0_30px_70px_-25px_rgba(0,0,0,0.3)] transition-all"
            >
              <div className="aspect-[3/4] overflow-hidden bg-gray-200">
                <img
                  src={m.image}
                  alt={m.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-x-0 bottom-0 p-5 bg-gradient-to-t from-black/85 via-black/30 to-transparent text-white">
                <div className="flex items-end justify-between">
                  <div>
                    <div className="font-display text-xl sm:text-2xl font-semibold tracking-tight">
                      {m.name}
                    </div>
                    <div className="font-mono-disp text-[11px] text-white/75 mt-1">
                      {m.role}
                    </div>
                  </div>
                  <div className="flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                    <span className="w-9 h-9 grid place-items-center rounded-full bg-[#FF5A00]">
                      <Linkedin className="w-4 h-4 text-white" />
                    </span>
                    <span className="w-9 h-9 grid place-items-center rounded-full bg-white/15 backdrop-blur">
                      <Mail className="w-4 h-4 text-white" />
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
